import apiClient from "QueryClient/axiosClient";

export const refreshAccessToken = async () => {
  // make api call to backend using refresh token
  return apiClient.get(`/auth/login`);
};
